import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";
import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

const columns = [
    {
        accessor: "item_name",
        header: "Item Name",
        cell: (row) => <>{row?.item_name ? row?.item_name : "-"}</>,
    },
    {
        accessor: "item_code",
        header: "Item Code",
        cell: (row) => <>{row?.item_code ? row?.item_code : "-"}</>,
    },
    {
        accessor: "threshold_amount",
        header: "MSQ",
        cell: (row) => (
            <>{row?.threshold_amount ? row?.threshold_amount : "-"}</>
        ),
    },
    {
        accessor: "stock_quantity",
        header: "Stock Quantity",
    },
    {
        accessor: "material_type",
        header: "Materical Type",
    },
    {
        accessor: "category",
        header: "Category",
    },
    {
        accessor: "status",
        header: "Status",
        cell: (row) =>
            !row?.item_status ? (
                <>
                    <span className="badge badge-dot bg-danger">Low Stock</span>
                </>
            ) : (
                <>
                    <span className="badge badge-dot bg-success">
                        Stock Available
                    </span>
                </>
            ),
        filterable: true,
        filterType: "dropdown",
        filterOpt: [
            { value: "available", label: "available" },
            { value: "low", label: "low" },
        ],
    },
];

const ItemStatus = () => {
    const privileges = secureLocalStorage.getItem("privileges");
    const [searchParams, setSearchParams] = useSearchParams();
    const initialEntries = Number(searchParams.get("entries")) || 10;
    const initialPage = Number(searchParams.get("page")) || 1;
    const initialQueries = searchParams.get("q")?.split(",") || [];
    const initialColumns = searchParams.get("c")?.split(",") || [];
    const [entries, setEntries] = useState(initialEntries);
    const [pageIndex, setPageIndex] = useState(initialPage - 1);
    const [globalFilterValue, setGlobalFilterValue] = useState("");
    const [columnFilterKey, setColumnFilterKey] = useState("");
    const [columnFilterValue, setColumnFilterValue] = useState("");
    const [itemStatus, setItemStatus] = useState("");

    const { useFetch } = useAPIQuery({
        key: "item",
        endpoint: "/api/item/",
    });

    const { data, isLoading, isFetching } = useFetch({
        params: {
            entries: entries,
            page_no: pageIndex + 1,
            action: "item_status",
            stock_status: itemStatus,
            q:
                globalFilterValue !== "" && itemStatus === ""
                    ? globalFilterValue
                    : columnFilterValue,
            c: globalFilterValue === "" ? columnFilterKey : "",
        },
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const handleGlobalFilterChange = (value) => {
        const q = value?.trim() || "";
        if (q !== "") {
            setGlobalFilterValue(q);
            setColumnFilterKey("");
            setColumnFilterValue("");
            setSearchParams((searchParams) => {
                searchParams.set("q", q);
                searchParams.delete("c");
                return searchParams;
            });
        } else if (q === "") {
            setGlobalFilterValue("");
            setSearchParams((searchParams) => {
                searchParams.delete("q");
                return searchParams;
            });
        }
    };

    const handleColumnFilterChange = (value) => {
        const q = value.map((val) => val.value?.trim() || "").join(",");
        const c = value.map((val) => val.id).join(",");
        if (q !== "" && c !== "") {
            setGlobalFilterValue("");
            setColumnFilterKey(c);
            setColumnFilterValue(q);
            setSearchParams((searchParams) => {
                searchParams.set("q", q);
                searchParams.set("c", c);
                return searchParams;
            });
        } else if (q === "" && c === "") {
            setColumnFilterKey("");
            setColumnFilterValue("");
            setSearchParams((searchParams) => {
                searchParams.delete("q");
                searchParams.delete("c");
                return searchParams;
            });
        }
    };

    const handlePagination = (value) => {
        setSearchParams((searchParams) => {
            searchParams.set("entries", value.pageSize);
            searchParams.set("page", value.pageIndex + 1);
            return searchParams;
        });
        setPageIndex(value.pageIndex);
        setEntries(value.pageSize);
    };

    console.log(data);

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content d-flex">
                        <h3 className="nk-block-title page-title">
                            Item Status
                        </h3>
                    </div>
                </div>
            </div>

            <Table
                data={data ? data?.results.data : []}
                columns={columns}
                pagination
                pageIndex={pageIndex}
                pageSize={entries}
                rowCount={data ? data.count : 0}
                isLoading={isLoading || isFetching}
                globalSearch
                filterModal={false}
                selectRows={false}
                editRows={false}
                deleteRows={false}
                defaultGlobalSearchValue={
                    initialQueries.length > 0 && initialColumns.length <= 0
                        ? initialQueries[0]
                        : undefined
                }
                defaultColumnFiltersValue={
                    initialQueries.length > 0 && initialColumns.length > 0
                        ? initialColumns.map((column, index) => ({
                              id: column,
                              value: initialQueries?.[index] ?? "",
                          }))
                        : undefined
                }
                onGlobalFilterChange={handleGlobalFilterChange}
                onColumnFilterChange={handleColumnFilterChange}
                onPaginationChange={handlePagination}
            />
        </>
    );
};

export default ItemStatus;
